/**
 * Chat API service layer for conversational commerce.
 */

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

function getAuthHeaders() {
  const token = sessionStorage.getItem('session_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export async function createChatSession() {
  const res = await fetch(`${API_BASE}/v1/chat/sessions`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listChatSessions(limit = 20) {
  const res = await fetch(`${API_BASE}/v1/chat/sessions?limit=${limit}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getChatSession(sessionId) {
  const res = await fetch(`${API_BASE}/v1/chat/sessions/${sessionId}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getChatMessages(sessionId, limit = 50) {
  const res = await fetch(`${API_BASE}/v1/chat/sessions/${sessionId}/messages?limit=${limit}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

/**
 * Send a message and return an SSE EventSource-like async iterator.
 * Uses fetch + ReadableStream for SSE parsing.
 */
export async function sendChatMessage(sessionId, message, mode = 'default') {
  const res = await fetch(`${API_BASE}/v1/chat/sessions/${sessionId}/messages`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ message, mode }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.body;
}
